import { render, staticRenderFns } from "./MarkupSession.vue?vue&type=template&id=34b25af6&scoped=true"
import script from "./MarkupSession.vue?vue&type=script&lang=js"
export * from "./MarkupSession.vue?vue&type=script&lang=js"
import style0 from "./MarkupSession.vue?vue&type=style&index=0&id=34b25af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b25af6",
  null
  
)

export default component.exports